// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"148":"27c71762","949":"37f79b57"}[chunkId] + ".chunk.css";
};